<div *ngIf="isJobSeeker" class="ogloginpage">
    <img style="max-width: 14rem" *ngIf="showImg"
        src="assets/img/jtsusalogo.png" alt="">
    <div [class]="(isForgetPassword ? 'loginwrap loginwrap-reset-psw' : 'loginwrap') " style ="overflow: inherit;">
        <div *ngIf="!isForgetPassword">
            <div class="oglogo">
                <img style="max-width: 14rem;" *ngIf="showLogo" src="assets/img/Gsti_USA_Logo.svg" alt="">
                <img style="max-width: 14rem;" *ngIf="showLogo2" src="assets/img/JTSiindia-Logo1.png" alt="">
                <img style="max-width: 14rem;" *ngIf="showLogo3" src="assets/img/MCF-Logo.png" alt="">
                <img style="max-width: 17rem;" *ngIf="showLogoPG" src="assets/img/pglogo.png" alt="PG website logo">
                <p>
                    <span style="font-size: 2rem;font-weight: bold;"> Register & Login to your account</span>
                </p>
            </div>
            <form class="newloginfields" [formGroup]="loginForm" (ngSubmit)="onSubmitRegisterForm()">
                <div class="logincolumn">
                    <div class="formside" style="justify-items: flex-start;">
                        <label for="" class="control-label">First Name<span>*</span></label>
                        <div class="formfields" style="padding-top: 0;">
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newuser"></use>
                            </svg>
                            <input type="text" placeholder="First Name" formControlName="firstName" tabindex="1">
                        </div>
                        <label for="" class="control-label">Last Name<span>*</span></label>
                        <div class="formfields" style="padding-top: 0;">
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newuser"></use>
                            </svg>
                            <input type="text" placeholder="Last Name" formControlName="lastName" tabindex="1">
                        </div>
                        <label for="" class="control-label">Contact Number<span>*</span></label>
                        <div class="formfields">
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newuser"></use>
                            </svg>
                            <input class="form-control" type="phone" name="" placeholder="Contact" formControlName="contact"
                                (change)="validatephonenum($event)" [mask]="phoneformat==2 ? maskphone : maskphoneIND" 
                                [showMaskTyped]="true"
                                (keypress)="validatephone($event)">                               
                        </div>
                        <label for="" class="control-label">Email<span>*</span></label>
                        <div class="formfields" style="padding-top: 0;">
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newuser"></use>
                            </svg>
                            <input type="text" placeholder="Email" formControlName="email" tabindex="1">
                        </div>
                        <label for="" class="control-label">Password<span>*</span></label>
                        <div class="formfields">
                            <button class="textviewbtns" type="button" (click)="hide=!hide">
                                <svg *ngIf="hide">
                                    <use xlink:href="assets/img/sprite.svg#closedeye"></use>
                                </svg>
                                <svg *ngIf="!hide">
                                    <use xlink:href="assets/img/sprite.svg#openedeye"></use>
                                </svg>
                            </button>
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newpassword"></use>
                            </svg>
                            <input type="password" placeholder="Password" formControlName="password"
                            (focus)="ispasswordFocused=true"
                            (blur)="ispasswordFocused=false"
                            (input)="ValidatePassword($event)" [type]="hide ? 'password': 'text'" tabindex="2">
                                <span class="validatetooltipcontent" 
                                    *ngIf="ispasswordFocused && loginForm.get('password')?.value">
                                    <ul class="ticklist">
                                        <span class="tooltiptitle"> {{passwordtootiptitle}}</span>
                                        <li *ngFor="let item of passwordtooltip;let index=index" [class.red]="!passwordvalidation[index]" [class.green]="passwordvalidation[index]">
                                            <span> {{item}}</span>
                                        </li>
                                    </ul>
                                </span>
                            <div class="passwordinfo">
                                ?
                                <span class="logintooltipcontent">
                                    <ul class="ticklist">
                                        <span class="tooltiptitle"> {{passwordtootiptitle}}</span>
                                        <li *ngFor="let item of passwordtooltip;let index" [class.red]="true">
                                            <span> {{item}}</span>
                                        </li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <button class="newlogbtn" type="submit">Register & Log In</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- <div class="testReqMail">
    <button (click)="sendDailyReqMail()">Send Daily Requisiton Mail</button>
</div> -->
<div *ngIf="!isJobSeeker" class="ogloginpage">
    <img style="max-width: 14rem" *ngIf="showImg"
        src="assets/img/jtsusalogo.png" alt="">
    <div [class]="(isForgetPassword ? 'loginwrap loginwrap-reset-psw' : 'loginwrap') " style ="overflow: inherit;">
        <div *ngIf="!isForgetPassword">
            <div class="oglogo">
                <img style="max-width: 14rem;" *ngIf="showLogo" src="assets/img/Gsti_USA_Logo.svg" alt="">
                <img style="max-width: 14rem;" *ngIf="showLogo2" src="assets/img/JTSiindia-Logo1.png" alt="">
                <img style="max-width: 14rem;" *ngIf="showLogo3" src="assets/img/MCF-Logo.png" alt="">
                <img style="max-width: 17rem;" *ngIf="showLogoPG" src="assets/img/pglogo.png" alt="PG website logo">
                <p>
                    <span style="font-size: 2rem;font-weight: bold;"> Login to your account</span>
                </p>
            </div>
            <form class="newloginfields" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="loginoptions">
                    <div class="radioGroup">
                        <input class="radioBtn" name="loginoption" [checked]="currentlyChecked ===check_box_type.PSW"
                            (click)="selectCheckBox(check_box_type.PSW)" id="mytodolist" type="radio" />
                        <label for="mytodolist"><span></span>With Password
                        </label>
                    </div>
                    <div class="radioGroup">
                        <input class="radioBtn" name="loginoption"
                            [checked]="currentlyChecked ===check_box_type.FACE_ID"
                            (click)="selectCheckBox(check_box_type.FACE_ID)" id="teamtodolist" type="radio" />
                        <label for="teamtodolist"><span></span>With Face ID
                        </label>
                    </div>
                </div>
                <div class="logincolumn">
                    <div class="formside">
                        <div class="formfields" style="padding-top: 0;" *ngIf="!(loginType == 'FACE_ID')">
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newuser"></use>
                            </svg>
                            <input type="text" placeholder="Email" formControlName="email" tabindex="1">
                        </div>
                        <div class="formfields" *ngIf="!(loginType == 'FACE_ID')">
                            <button class="textviewbtns" type="button" (click)="hide=!hide">
                                <svg *ngIf="hide">
                                    <use xlink:href="assets/img/sprite.svg#closedeye"></use>
                                </svg>
                                <svg *ngIf="!hide">
                                    <use xlink:href="assets/img/sprite.svg#openedeye"></use>
                                </svg>
                            </button>
                            <svg>
                                <use xlink:href="assets/img/sprite.svg#newpassword"></use>
                            </svg>
                            <input type="password" placeholder="Password" formControlName="password"
                            (focus)="ispasswordFocused=true"
                            (blur)="ispasswordFocused=false"
                            (input)="ValidatePassword($event)" [type]="hide ? 'password': 'text'" tabindex="2">
                            
                                <span class="validatetooltipcontent" 
                                    *ngIf="ispasswordFocused && loginForm.get('password')?.value">
                                    <ul class="ticklist">
                                        <span class="tooltiptitle"> {{passwordtootiptitle}}</span>
                                        <li *ngFor="let item of passwordtooltip;let index=index" [class.red]="!passwordvalidation[index]" [class.green]="passwordvalidation[index]">
                                            <span> {{item}}</span>
                                        </li>
                                    </ul>
                                </span>
                            <div class="passwordinfo">
                                ?
                                <span class="logintooltipcontent">
                                    <ul class="ticklist">
                                        <span class="tooltiptitle"> {{passwordtootiptitle}}</span>
                                        <li *ngFor="let item of passwordtooltip;let index" [class.red]="true">
                                            <span> {{item}}</span>
                                        </li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <div class="formfields" *ngIf="!(loginType == 'FACE_ID')">
                            <ngx-recaptcha2 #captchaElem class="og-recaptcha" [siteKey]="siteKey"
                                (reset)="handleReset()" (expire)="handleExpire()" (error)="handleError()"
                                (load)="handleLoad()" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                [size]="size" [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha">
                            </ngx-recaptcha2>
                        </div>
                        <button class="newlogbtn" type="submit"
                            *ngIf="!(loginType == 'FACE_ID')">{{labelLogin.signin}}</button>
                        <div class="logincapture" *ngIf="(loginType == 'FACE_ID')">
                            <div class="faceCapture" style="display: grid;
                            align-items: center;
                            justify-content: center;">
                                <button class="flip" style="z-index: 100;display: none;" (click)="showNextWebcam(true);"
                                    [disabled]="!multipleWebcamsAvailable">
                                    <svg>
                                        <use xlink:href="./assets/img/sprite.svg#flipcamera"></use>
                                    </svg>
                                </button>
                                <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                                    *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                                    [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
                                    [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
                                    (initError)="handleInitError($event)" style="width: 100%;height: 100%;"></webcam>

                            </div>
                        </div>
                        <button title="Compare" style="margin-bottom: 0;" class="newlogbtn"
                            *ngIf="(loginType == 'FACE_ID')" (click)="compareImage()"
                            [ngClass]="(!(showWebcam)?'disable-click':'enable-click')">
                            {{labelLogin.signin}}
                        </button>
                        <p *ngIf="!(loginType == 'FACE_ID')">
                            <a class="link" [routerLink]="" (click)="forgetPassword()" #reset>{{labelLogin.forgetpassowrd}}</a>
                        </p>
                    </div>
                </div>
            </form>
            <div class="newloginfooter">
                <p class="signupnow">
                    {{labelLogin.haveaccount}}
                </p>
            </div>
        </div>
        <div class="logincolumn" *ngIf="isForgetPassword">
            <div class="forgotcolumn">
                <a [routerLink]="" class="backtologin" (click)="backToLogin()"> <span> &larr; </span> Back to
                    Login
                </a>
                <h2 style="font-size: 4.2rem">
                    <strong>Resetting your password</strong>
                </h2>
                <p>
                </p>
                <form [formGroup]="resetPasswordForm">
                    <div class="sendemail">
                        <input type="text" [ngClass]="{'is-invalid': submitted && f['username'].errors}"
                            formControlName="username" class="form-control custext"
                            placeholder="youremail@emails.com" />
                        <button class="newlogbtn " style="max-width: 10rem; margin-left: auto;"
                            (click)="validateUsername()">Reset</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<footer>
    <p [innerHTML]="loaderService.footerContent | async"></p>
</footer>